import React from 'react';
import type { LaneConfig, PhysicsBall } from '../engine/types';
import type { FunilCampaignSwatch } from '../funilCampaignPalette';
import { PhysicsBallComponent } from './PhysicsBall';
import { HeadsetUserIcon } from './HeadsetUserIcon';

interface PhysicsLaneProps {
  config: LaneConfig;
  balls: PhysicsBall[];
  activeCount: number;
  laneRef: React.RefObject<HTMLDivElement | null>;
  humanRef: React.RefObject<HTMLDivElement | null>;
  /**
   * `true` (default): bolinha com gradiente da *campanha* (slides / compat).
   * `false` (FunilIa *physics*): cor por etapa, como a borda esquerda.
   */
  useCampaignSwatch?: boolean;
  swatchForCampaign: (campaignId: string) => FunilCampaignSwatch;
  registerBall: (leadId: string, el: HTMLElement | null) => void;
  onBallClick?: (leadId: string) => void;
  /** F4.5: esconde o card «Humano» por *lane* quando a coluna de bins partilhada está activa. */
  hideLaneHuman?: boolean;
}

export const PhysicsLane: React.FC<PhysicsLaneProps> = ({
  config,
  balls,
  activeCount,
  laneRef,
  humanRef,
  useCampaignSwatch = true,
  swatchForCampaign,
  registerBall,
  onBallClick,
  hideLaneHuman = false,
}) => {
  return (
    <div className="funil-ia-lane" data-lane={config.key}>
      <div className="funil-ia-lane-accent" />
      <div className="funil-ia-lane-meta">
        <div className="funil-ia-lane-title">{config.title}</div>
        <div className="funil-ia-lane-desc">{config.description}</div>
        <div className="funil-ia-lane-count">
          <span className="funil-ia-lane-count-swatch" style={{ background: config.accent }} />
          {activeCount} ativo{activeCount !== 1 ? 's' : ''}
        </div>
      </div>
      <div className="funil-ia-lane-road" ref={laneRef as React.RefObject<HTMLDivElement>}>
        <svg className="funil-ia-wire" aria-hidden>
          <path
            d="M 0,50% Q 33%,35% 66%,50% T 100%,50%"
            fill="none"
            stroke={config.accent}
            strokeWidth="1"
            strokeOpacity="0.12"
          />
        </svg>
        {balls.map((ball) => (
          <PhysicsBallComponent
            key={ball.leadId}
            leadId={ball.leadId}
            lane={ball.lane}
            initial={ball.initial}
            leadName={ball.leadName}
            campaignId={ball.campaignId}
            swatch={useCampaignSwatch ? swatchForCampaign(ball.campaignId) : undefined}
            registerBall={registerBall}
            onClick={onBallClick ? () => onBallClick(ball.leadId) : undefined}
          />
        ))}
      </div>
      {!hideLaneHuman && (
        <div className="funil-ia-lane-human" ref={humanRef as React.RefObject<HTMLDivElement>}>
          <div className="funil-ia-human-target">
            <div className="funil-ia-ring" />
            <div className="funil-ia-ring funil-ia-r2" />
            <div className="funil-ia-icon">
              <HeadsetUserIcon size={16} />
            </div>
          </div>
          <span className="funil-ia-human-label">Humano</span>
        </div>
      )}
      {hideLaneHuman && (
        <div
          className="funil-ia-lane-human funil-ia-lane-human--sr"
          ref={humanRef as React.RefObject<HTMLDivElement>}
          aria-hidden
        />
      )}
    </div>
  );
};
